<script setup>
const fullWidthMode = inject("fullWidthMode", false);
const halfCol = computed(() => (fullWidthMode ? undefined : 6));
import { useAnalysisStore } from '@/store/modules/analysis'
import {
  removeAsterisk,
  splitKeywordParts,
  splitBySentence,
  splitSentencesByDivider,
  transformMarkedText,
} from '@/composables/splitSentence'
import PersonalSpiderChart from './PersonalSpiderChart.vue'
import PersonalStrWea from './PersonalStrWea.vue';
import { useParsedStWeText } from '@/composables/useParsedStWeText.js';

const props = defineProps({
  pData: Object,
  userName: String,
  isMobile: Boolean,
})
const store = useAnalysisStore()
// const userName = computed(() => store.userName)
onMounted(() => {
  // pData.value = store.analysisResult;
})

const rawChartDesc= computed(() =>{
  const sentences = splitBySentence(props.pData.정보수집상세.결과요약 || '')
  return sentences.map(sentence => transformMarkedText(sentence))
})

const rawStWeData = computed(() => props.pData.정보수집상세.상세해석)
const {
  parsedStrengthMain,
  parsedStrengthDetail,
  parsedWeaknessMain,
  parsedWeaknessDetail,
} = useParsedStWeText(rawStWeData)

// 차트데이터
const chartData = computed(() => props.pData.정보수집상세.특성통계)
</script>

<template>
  <VRow class="full-height">
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-first">
      <VCard class="personality-card full-height right">
        <div class="personality-wrapper">
          <div class="person-desc-box">
            <div class="desc__title">🧐 정보를 바라보는 나의 스타일을 더 깊게 살펴볼까요?</div>
            <div class="person-spider-wrapper">
              <PersonalSpiderChart 
                :chartData="chartData"
                :isMobile="isMobile"
              />
            </div>
          </div>

          <div class="person-content-box">
            <div v-for="(html, idx) in rawChartDesc" :key="idx">
              <span class="content__body-txt" v-html="html" />
            </div>
          </div>
        </div>
      </VCard>
    </VCol>
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-second">
      <VCard class="personality-card full-height">
        <div class="personality-wrapper">
          <div class="person-desc-box">
            <div class="desc__title">💪 이런 강점이 있어요.</div>
            <div class="desc__body">
              <PersonalStrWea
                :firstKeyword="props.pData.정보수집상세.강점약점[0]"
                :secondKeyword="props.pData.정보수집상세.강점약점[1]"
                :isMobile="isMobile"
              />
              <div class="desc__body-highlight">
                <div
                  :key="'sm' + idx"
                  class="content__body-txt"
                  v-html="parsedStrengthMain"
                />
              </div>
              <div class="desc__body-padd">
                <div
                  :key="'sm' + idx"
                  class="content__body-txt"
                  v-html="parsedStrengthDetail"
                />
              </div>

              <div v-if="parsedWeaknessMain.length > 0" class="desc__body-gray">
                <div
                  :key="'sm' + idx"
                  class="content__body-txt"
                  v-html="parsedWeaknessMain"
                />
              </div>

              <div class="desc__body-padd">
                <div
                  :key="'sm' + idx"
                  class="content__body-txt"
                  v-html="parsedWeaknessDetail"
                />
              </div>
            </div>
          </div>
        </div>
      </VCard>
    </VCol>
  </VRow>
</template>
